import axios from 'axios'

export const CountryDetailsService = {
  // get country details list
  fetchCountryDetails (data) {
    return axios.get('/public/api/v1/country/adoption', {
      params: {
        countryName: data.countryName
      }
    })
  }
}
